<template>
  <div class="left_col scroll-view">
    <div class="clearfix"></div>
    <!-- sidebar menu -->
    <div id="sidebar-menu" class="main_menu_side hidden-print main_menu">
      <div class="menu_section">
        <ul class="nav side-menu">
          <li :class="includeRoute(['/admin/dashboard' ], this.$route.path) ? 'active': ''" @click=checkMenu><router-link to="/admin/dashboard"><i class="fa fa-dashboard"></i>{{$t('menu.dashboard')}}</router-link></li>
          <li :class="includeRoute(['/admin/report' ], this.$route.path) ? 'active': ''" @click=checkMenu><router-link to="/admin/report"><i class="fa fa-pie-chart"></i>{{$t('menu.report')}}</router-link></li>
          <li :class="includeRoute(['/admin/customer' ], this.$route.path) ? 'active': ''" @click=checkMenu><router-link to="/admin/customer"><i class="fa fa-users"></i>{{$t('menu.orderManagement')}}</router-link></li>
          <li :class="includeRoute(['/admin/employee' ], this.$route.path) ? 'active': ''" @click=checkMenu><router-link to="/admin/employee"><i class="fa fa-user"></i>{{$t('menu.employeeManager')}}</router-link></li>
          <!-- <li :class="includeRoute(['admin/order' ], this.$route.path) ? 'active': ''" @click=checkMenu><router-link to="/admin/order"><i class="fa fa-phone"></i>{{$t('menu.careOrder')}}</router-link></li> -->
          <li :class="includeRoute(['/admin/import' ], this.$route.path) ? 'active': ''" @click=checkMenu><router-link to="/admin/import"><i class="fa fa-upload"></i>{{$t('menu.import')}}</router-link></li>
          <!-- <li :class="includeRoute(['admin/data' ], this.$route.path) ? 'active': ''" @click=checkMenu><router-link to="/admin/data"><i class="fa fa-table"></i>{{$t('menu.manageDataTypes')}}</router-link></li> -->
           <li :class="includeRoute(['/admin/import-history' ], this.$route.path) ? 'active': ''" @click=checkMenu><router-link to="/admin/import-history"><i class="fa fa-history"></i>Lịch sử Import</router-link></li>
           <li :class="includeRoute(['/admin/send-zns' ], this.$route.path) ? 'active': ''" @click=checkMenu><router-link to="/admin/send-zns"><i class="fa fa-paper-plane"></i>Gửi ZNS</router-link></li>
            <li :class="includeRoute(['/admin/zns-history' ], this.$route.path) ? 'active': ''" @click=checkMenu><router-link to="/admin/zns-history"><i class="fa fa-clock-o"></i>Lịch sử ZNS</router-link></li>
        </ul>
      </div>
    </div>
    <!-- /sidebar menu -->
  </div>
</template>

<script>
export default {
  name: 'MenuSideBar',
  mounted() {
  },
  methods: {
    includeRoute(paths, route) {
      return paths.includes(route);
    },
	checkMenu() {
	  this.$emit('check-menu')
	}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
  .left_col{

  }
</style>
